<template>
  <main id="content">
    <section class="pt-4 pb-4">
      <b-container style="max-width: 900px">
        <b-row>
          <b-col md="4">
            <SettingsNav />
          </b-col>
          <b-col md="8" v-if="loading" data-aos="fade-down-left">
            <div
              class="card card-body p-5 d-flex align-items-center text-muted"
            >
              <font-awesome-icon icon="sync" size="2x" spin />
            </div>
          </b-col>
          <b-col md="8" v-else data-aos="fade-up-left">
            <div class="card card-body" v-if="payment.masked_number">
              <h2 class="h4 mb-3">My Card</h2>
              <div class="d-flex justify-content-center">
                <div class="card card-body credit-card">
                  <div class="text">
                    <div class="d-flex justify-content-end">
                      <div class="company-icon">
                        <font-awesome-icon
                          v-if="payment.card_type === 'Visa'"
                          :icon="{ prefix: 'fab', iconName: 'cc-visa' }"
                        />
                        <font-awesome-icon
                          v-else-if="payment.card_type === 'MasteCard'"
                          :icon="{ prefix: 'fab', iconName: 'cc-mastercard' }"
                        />
                        <font-awesome-icon
                          v-else-if="payment.card_type === 'American Express'"
                          :icon="{ prefix: 'fab', iconName: 'cc-amex' }"
                        />
                        <font-awesome-icon
                          v-else-if="payment.card_type === 'Discover'"
                          :icon="{ prefix: 'fab', iconName: 'cc-discover' }"
                        />
                        <font-awesome-icon
                          v-else-if="payment.card_type === 'JCB'"
                          :icon="{ prefix: 'fab', iconName: 'cc-jcb' }"
                        />
                        <font-awesome-icon
                          v-else-if="payment.card_type === 'Diners Club'"
                          :icon="{ prefix: 'fab', iconName: 'cc-diners-club' }"
                        />
                        <font-awesome-icon v-else icon="credit-card" />
                      </div>
                    </div>
                    <p class="text-center mt-4 mb-5 number">
                      <!-- Do some masking here -->
                      <span
                        v-for="index in 3"
                        :key="index"
                        style="margin-right:10px;font-weight:bold;"
                      >
                        <span v-for="index in 4" :key="index">&middot;</span>
                      </span>
                      {{ payment.masked_number }}
                    </p>
                    <b-row>
                      <b-col>
                        <div>{{ payment.fullName }}</div>
                      </b-col>
                      <b-col>
                        <div class="text-right">
                          {{ payment.expiryMonth }}/{{ payment.expiryYear }}
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                  <div class="lines-up"></div>
                  <div class="lines-down"></div>
                </div>
              </div>
              <div class="mt-4">
                <b-button
                  id="btnPaymentCardDeleteButton"
                  v-b-modal.deleteModal
                  variant="outline-danger"
                  class="icon-left"
                  :disabled="check_paid_subscription"
                >
                  <font-awesome-icon icon="trash" />Delete this card
                </b-button>
                <p v-if="check_paid_subscription" class="text-danger">
                  First cancle a subscription then you can delete a card
                </p>
              </div>
              <b-modal
                id="deleteModal"
                title="Delete card"
                @ok="deleteAction"
                ok-variant="danger"
                ok-title="Yes, delete my card"
                cancel-title="No, update my card details"
              >
                <p>
                  Are you sure you want to delete your card? This action is
                  irreversible, and may lead to the cancellation of your
                  subscription if we're not able to charge you.
                </p>
              </b-modal>
            </div>
            <div class="card card-body">
              <h2 class="h4 mb-3">
                <span v-if="payment.masked_number">Update</span>
                <span v-else>Add</span> Card
              </h2>
              <b-form @submit.prevent>
                <b-row>
                  <b-col md>
                    <b-form-group label="First name">
                      <b-form-input
                        type="text"
                        id="txtPaymentAddCardfirstName"
                        v-model="payment.firstName"
                        placeholder="Enter your first name"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md>
                    <b-form-group label="Last name">
                      <b-form-input
                        type="text"
                        id="txtPaymentAddCardLastName"
                        v-model="payment.lastName"
                        placeholder="Enter your last name"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-form-group v-if="!payment.masked_number" label="Card number">
                  <card
                    id="txtPaymentAddCardCardNumber"
                    class="stripe-card form-control"
                    :class="{ complete }"
                    stripe="pk_live_DtijabclrmQxeHj5lZZxVzLL"
                    @change="complete = $event.complete"
                  />
                </b-form-group>
                <transition name="fade">
                  <b-button
                    id="btnPaymentAddCardSaveButton"
                    v-if="!payment.masked_number"
                    type="submit"
                    variant="primary"
                    @click="addPaymentMethod"
                    :disabled="!complete"
                  >
                    <span v-if="show">
                      Save card
                      <font-awesome-icon icon="arrow-right" />
                    </span>
                    <span v-else>
                      Saving card &nbsp;
                      <font-awesome-icon icon="sync" spin />
                    </span>
                  </b-button>
                </transition>
                <transition name="fade">
                  <b-button
                    v-if="payment.masked_number"
                    type="submit"
                    variant="primary"
                    @click="updateAction"
                  >
                    <span v-if="show">
                      Save card
                      <font-awesome-icon icon="arrow-right" />
                    </span>
                    <span v-else>
                      Saving card &nbsp;
                      <font-awesome-icon icon="sync" spin />
                    </span>
                  </b-button>
                </transition>
              </b-form>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getCreditCardDetails,
  addCreditCardDetails,
  updateCreditCardDetails,
  deleteCreditCard
} from "../modules/database";
// import { createStripeToken } from ""
import constants from "../modules/constants";
import SettingsNav from "../components/SettingsNav.vue";

// import { stripeKey, stripeOptions } from 'stripeConfig.json'
import { Card, createToken } from "vue-stripe-elements-plus";

export default {
  // props: [ 'stripe', 'options' ],
  data: () => {
    return {
      payment: {
        status: "",
        firstName: "",
        lastName: "",
        cardNumber: "",
        expiryMonth: 1,
        subscriptions: [],
        expiryYear: new Date().getFullYear() + 1,
        cvv: "",
        masked_number: "",
        funding_type: "",
        card_type: ""
      },
      years: [],
      check_paid_subscription: false,
      show: true,
      loading: false,
      complete: false
    };
  },
  components: {
    SettingsNav,
    Card
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      customer: "getCustomer",
      subscriptions: "getSubscriptions"
    })
  },
  mounted() {
    this.loading = true;
    this.listSubscriptions();
    this.check_paid_subscriptions();
    getCreditCardDetails()
      .then(card => {
        if (card.metadata.firstName)
          this.payment.firstName = card.metadata.firstName;
        if (card.metadata.lastName)
          this.payment.lastName = card.metadata.lastName;
        if (card.name) this.payment.fullName = card.name;
        if (card.expiry_month) this.payment.expiryMonth = card.expiry_month;
        if (card.expiry_year) this.payment.expiryYear = card.expiry_year;
        if (card.last4) this.payment.masked_number = card.last4;
        if (card.funding) this.payment.funding_type = card.funding;
        if (card.brand) this.payment.card_type = card.brand;
      })
      .catch(error => {
        console.log("error", error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    check_paid_subscriptions() {
      for (let index = 0; index < this.subscriptions.length; index++) {
        const amount = this.subscriptions[index].items.data[0].plan.amount;
        const cancel = this.subscriptions[index].cancel_at_period_end;
        if (amount != 0 && cancel == false) {
          this.check_paid_subscription = true;
        } else {
          this.check_paid_subscription = false;
        }
      }
    },
    addPaymentMethod() {
      this.show = false;
      var options = {
        name: this.payment.firstName + " " + this.payment.lastName,
        metadata: {
          firstName: this.payment.firstName,
          lastName: this.payment.lastName
        }
      };
      createToken(options).then(data =>
        addCreditCardDetails(data.token.id)
          .then(card => {
            this.$root.toast(constants.info.card_added);
            this.show = true;
            this.payment.firstName = card.metadata.firstName;
            this.payment.lastName = card.metadata.lastName;
            this.payment.fullName = card.name;
            this.payment.expiryMonth = card.expiry_month;
            this.payment.expiryYear = card.expiry_year;
            this.payment.masked_number = card.last4;
            this.payment.funding_type = card.funding;
            this.payment.card_type = card.brand;
          })
          .catch(() => {
            this.$root.toast(constants.errors.card_add_error);
          })
          .finally(() => {
            this.show = true;
          })
      );
    },
    listSubscriptions() {
      this.loading1 = true;
      this.subscriptionPrice = 0;
      this.$store.dispatch("fetchUserSubscriptions").finally(() => {
        this.loading1 = false;
      });
    },
    deleteAction() {
      this.loading = true;
      this.show = false;
      deleteCreditCard()
        .then(() => {
          this.$root.toast(constants.info.card_deleted);
          this.payment.firstName = "";
          this.payment.lastName = "";
          this.payment.expiryMonth = "";
          this.payment.expiryYear = "";
          this.payment.masked_number = "";
          this.payment.funding_type = "";
          this.payment.card_type = "";
          this.payment.cvv = "";
        })
        .catch(() => {
          this.$root.toast(constants.errors.card_delete_error);
        })
        .finally(() => {
          this.loading = false;
          this.show = true;
        });
    },
    updateAction() {
      this.show = false;
      updateCreditCardDetails(this.payment.firstName, this.payment.lastName)
        .then(() => {
          getCreditCardDetails()
            .then(card => {
              this.$root.toast(constants.info.card_updated);
              this.loading = true;
              if (card.metadata.firstName)
                this.payment.firstName = card.metadata.firstName;
              if (card.metadata.lastName)
                this.payment.lastName = card.metadata.lastName;
              if (card.name) this.payment.fullName = card.name;
              if (card.expiry_month)
                this.payment.expiryMonth = card.expiry_month;
              if (card.expiry_year) this.payment.expiryYear = card.expiry_year;
              if (card.last4) this.payment.masked_number = card.last4;
              if (card.funding) this.payment.funding_type = card.funding;
              if (card.brand) this.payment.card_type = card.brand;
            })
            .catch(error => {
              console.log("error", error);
            })
            .finally(() => {
              this.loading = false;
              this.show = true;
            });
        })
        .catch(() => {
          this.$root.toast(constants.errors.card_error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.ElementsApp,
.ElementsApp .InputElement {
  font-family: "Muli", sans-serif !important;
  color: #495057;
}
.stripe-card.complete {
  border-color: green;
}
.credit-card {
  max-width: 400px;
  overflow: hidden;
  background: #23189a;
  border: 1px solid #1e1584;
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.9);
  .company-icon {
    font-size: 250%;
    margin-top: -0.75rem;
    color: #fdcb6e;
  }
  .text {
    position: relative;
    z-index: 15;
  }
  .number {
    letter-spacing: 5px;
    font-size: 115%;
  }
  .lines-down:before {
    content: "";
    position: absolute;
    top: 80px;
    left: -200px;
    z-index: 10;
    width: 550px;
    height: 400px;
    border-top: 2px solid #392db2;
    -webkit-border-radius: 40% 60% 0 0;
    -webkit-background-clip: padding-box;
    -moz-border-radius: 40% 60% 0 0;
    -moz-background-clip: padding;
    border-radius: 40% 60% 0 0;
    background-clip: padding-box;
    box-shadow: 1px 1px 100px #4035b2;
    background: #2d21a6;
    background: radial-gradient(
      ellipse at center,
      rgba(45, 33, 166, 0) 44%,
      #2d21a6 100%
    );
  }
  .lines-down:after {
    content: "";
    position: absolute;
    top: 20px;
    left: -100px;
    z-index: 10;
    width: 350px;
    height: 400px;
    border-top: 2px solid #392db2;
    -webkit-border-radius: 20% 80% 0 0;
    -webkit-background-clip: padding-box;
    -moz-border-radius: 20% 80% 0 0;
    -moz-background-clip: padding;
    border-radius: 20% 80% 0 0;
    background-clip: padding-box;
    box-shadow: inset -1px -1px 44px #4035b2;
    background: #2d21a6;
    background: radial-gradient(
      ellipse at center,
      rgba(45, 33, 166, 0) 44%,
      #2d21a6 100%
    );
  }
  .lines-up:before {
    content: "";
    position: absolute;
    top: -110px;
    left: -70px;
    z-index: 2;
    width: 480px;
    height: 300px;
    border-bottom: 2px solid #392db2;
    -webkit-border-radius: 0 0 60% 90%;
    -webkit-background-clip: padding-box;
    -moz-border-radius: 0 0 60% 90%;
    -moz-background-clip: padding;
    border-radius: 0 0 60% 90%;
    background-clip: padding-box;
    box-shadow: inset 1px 1px 44px #4035b2;
    background: #4031b2;
    background: radial-gradient(
      ellipse at center,
      rgba(64, 49, 178, 0) 44%,
      #23189a 100%
    );
  }
  .lines-up:after {
    content: "";
    position: absolute;
    top: -180px;
    left: -200px;
    z-index: 1;
    width: 530px;
    height: 420px;
    border-bottom: 2px solid #4035b2;
    -webkit-border-radius: 0 40% 50% 50%;
    -webkit-background-clip: padding-box;
    -moz-border-radius: 0 40% 50% 50%;
    -moz-background-clip: padding;
    border-radius: 0 40% 50% 50%;
    background-clip: padding-box;
    box-shadow: inset 1px 1px 44px #4035b2;
    background: #2d21a6;
    background: radial-gradient(
      ellipse at center,
      rgba(45, 33, 166, 0) 44%,
      #2d21a6 100%
    );
  }
}
</style>
<style>
body {
  background-color: #fff;
}
</style>
